/* 30th Anniversary Blend page: one quiet entrance per mural section (sections/custom-anniv-*.liquid).
   Several sections load this file; the guard makes it run once. Without JS, or with reduced motion,
   everything simply stays visible. */
(function () {
  if (window.__an30) return;
  window.__an30 = true;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function arm() {
    var targets = document.querySelectorAll('.an30-reveal, .an30-story__mark, .an30-reveal-group, .an30-wipe');
    if (!targets.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
    document.documentElement.classList.add('an30-armed');
    targets.forEach(function (t, i) {
      if (t.classList.contains('an30-reveal')) t.style.transitionDelay = (i % 4) * 90 + 'ms';
      if (t.classList.contains('an30-wipe')) t.style.setProperty('--an30-wipe-delay', (i % 5) * 0.09 + 's');
      io.observe(t);
    });
  }
  // Murals drift slightly slower than the page.
  function parallax() {
    var murals = [].slice.call(document.querySelectorAll('.an30-mural'));
    if (!murals.length) return;
    document.documentElement.classList.add('an30-parallax');
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      murals.forEach(function (m) {
        var r = m.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var offset = (r.top + r.height / 2 - vh / 2) * -0.06;
        m.style.setProperty('--an30-shift', offset.toFixed(1) + 'px');
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }
  function init() { arm(); parallax(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
